import base64 from "base-64";

export const renderDecodedId = (encodedBase64String: any) => {
  const id = base64.decode(encodedBase64String).split("\n")[1].slice(1);

  return id;
};
